import { COLUMN_ASSET_BATCHES } from "shared/constants/assetExporter";

export const getColumnTitle = (key: string) => {
  if (key === "order_number") return "";
  if (key === COLUMN_ASSET_BATCHES) return "Asset batches applied";

  return key;
};
